export default __webpack_public_path__ + "static/media/features_card3.bc8c81b7.svg";